import type { ValueTransformer } from 'typeorm';

/**
 * Maps a MySQL `tinyint(1)` flag to a real boolean. Without it the driver
 * hands back `0` / `1`, which reads correctly in an `if` but reaches API
 * callers as a number, and React renders a `{flag && ...}` guard that is `0`
 * as the text "0" (PD-16475). Mirrors the inline transformer on
 * `m_payment_isPrimary`.
 */
export const tinyintBoolean: ValueTransformer = {
	to: (
		value: boolean | number | null | undefined,
	): number | null | undefined =>
		value == null ? value : value === true || value === 1 ? 1 : 0,
	from: (value: boolean | number | null): boolean =>
		value === true || value === 1,
};
